<template>
  <div class="products">
      <div class="banner">
        <img src="../../static/img/cpbanner@2x.png" alt="">
      </div>
      <!-- 飞猪科技 -->
      <div class="fzkj">
        <div class="title">
            <p> <span class="xian"></span><span class="title_txt">飞猪科技</span></p>
        </div>
        <ul class="fzkj_list cent">
          <li v-for="(item,i) in fzkj" :key="i" class="cont_img"   @click="$router.push({path:item.path })">
            <img :src="item.img" alt="">
            <div class="listTxt">
              <h4>{{item.text}}</h4>
              <p>{{item.text1}}</p>
            </div>
          </li>
        </ul>
        <!-- 协和万邦 -->
        <div class="title">
            <p> <span class="xian"></span><span class="title_txt">协和万邦</span></p>
        </div>
        <ul class="xhwb_list cent">
          <li v-for="(item,i) in xhwb" :key="i" class="cont_img"   @click="$router.push({path:item.path })">
            <img :src="item.xbimg" alt="">
            <div class="listTxt">
              <h4>{{item.text}}</h4>
              <p>{{item.text1}}</p>
            </div>
          </li>
        </ul>
        <!-- 方胜磐石 -->
        <div class="title" >
            <p> <span class="xian"></span><span class="title_txt">方胜磐石</span></p>
        </div>
        <ul class="fsps_list cent">
         <li v-for="(item,i) in fsps" :key="i" class="cont_img" @click="$router.push({path:item.path })">
            <img :src="item.xbimg" alt="">
            <div class="listTxt">
               <h4>{{item.text}}</h4>
               <p>{{item.text1}}</p>
               <div class="more">
                <span>点击查看</span>
                <img src="../../static/img/三个圆点@2x.png" alt="">
               </div>
            </div>
           
          </li>

        </ul>
      </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      fzkj: [
        {
          img: require('../../static/img/飞猪保险——热保APP@2x.png'),
          text: '热保APP',
          text1: '热保APP，专为保险代理人打造...',
          path: '/fzproducts?id=0'

        },
        {
          img: require('../../static/img/飞猪保险——联合保APP@2x.png'),
          text: '联合保APP',
          text1: '联合保APP，专为保险代理人打造...',
          path: '/fzproducts?id=1'

        },
        {
          img: require('../../static/img/飞猪保险——小二APP@2x.png'),
          text: '小二APP',
          text1: '小二保险APP，专为保险代理人打...',
          path: '/fzproducts?id=2'

        },
        {
          img: require('../../static/img/飞猪保险——紫尊保APP@2x.png'),
          text: '紫尊保APP',
          text1: '紫尊保APP，专为保险代理人打造...',
          path: '/fzproducts?id=3'

        },
        {
          img: require('../../static/img/飞猪保险——利车保APP@2x.png'),
          text: '利车保APP',
          text1: '利车保APP，专为保险代理人打造...',
          path: '/fzproducts?id=4'

        },
        {
          img: require('../../static/img/飞猪保险——太慧宝APP@2x.png'),
          text: '太慧宝APP',
          text1: '太慧宝APP，专为保险代理人打造...',
         path: '/fzproducts?id=5'

        },
        {
          img: require('../../static/img/飞猪保险——鼎龙宝APP@2x.png'),
          text: '鼎龙宝APP',
          text1: '鼎龙宝APP，专为保险代理人打造...',
          path: '/fzproducts?id=6'

        },
        {
          img: require('../../static/img/飞猪保险——协保宝APP@2x.png'),
          text: '协保宝APP',
          text1: '协保宝APP，专为保险代理人打造...',
        path: '/fzproducts?id=7'

        },
        {
          img: require('../../static/img/飞猪保险——飞猪保险APP@2x.png'),
          text: '飞猪保险APP',
          text1: '飞猪保险APP，专为保险代理人打...',
          path: '/fzproducts?id=8'
        }
      ],
      xhwb: [
          {
            xbimg: require('../../static/img/协和万邦——寿险@2x.png'),
            text: '寿险',
            text1: '生活可靠有力的保障',
            path: '/xhproducts?id=0'

          },
        {
          xbimg: require('../../static/img/协和万邦——意外险@2x.png'),
          text: '意外险',
          text1: '随时随地、无时无刻的保护',
          path: '/xhproducts?id=1'

        },
        {
          xbimg: require('../../static/img/协和万邦——家财险@2x.png'),
          text: '家财险',
          text1: '房屋、家庭财产等均受保护',
          path: '/xhproducts?id=2'

        },
        {
          xbimg: require('../../static/img/协和万邦——车险@2x.png'),
          text: '车险',
          text1: '车辆险、附加险与交强险全面保护',
          path: '/xhproducts?id=3'

        }
      ],
      fsps: [
        {
          xbimg: require('../../static/img/方胜磐石——光大永明人寿@2x.png'),
          text: '光大永明人寿',
          text1: '吉瑞宝两全保险',
          path: '/fsproducts?id=0',
          id: '0'
        },
        {
          xbimg: require('../../static/img/方胜磐石——同方全球人寿@2x.png'),
          text: '同方全球人寿',
          text1: '康健一生（多倍保）终身重大疾病保险',
          path: '/fsproducts?id=1',
          id: '1'

        },
        {
          xbimg: require('../../static/img/方胜磐石——信泰人寿@2x.png'),
          text: '信泰人寿',
          text1: '千万传承终身寿险B 款',
          path: '/fsproducts?id=2',
          id: '2'

        },
        {
          xbimg: require('../../static/img/方胜磐石——工银安盛人寿@2x.png'),
          text: '工银安盛人寿',
          text1: '御享人生重大疾病保险',
          path: '/fsproducts?id=3',
          id: '3'

        },
        {
          xbimg: require('../../static/img/方胜磐石——长城人寿@2x.png'),
          text: '长城人寿',
          text1: '康健人生重大疾病保险',
          path: '/fsproducts?id=4',
          id: '4'

        },
        {
          xbimg: require('../../static/img/方胜磐石——华夏人寿@2x.png'),
          text: '华夏人寿',
          text1: '华夏福两全保险',
          path: '/fsproducts?id=5',
          id: '5'

        },
        {
          xbimg: require('../../static/img/方胜磐石——君康人寿@2x.png'),
          text: '君康人寿',
          text1: '多倍保重大疾病保险',
          path: '/fsproducts?id=6',
          id: '6'

        },
        {
          xbimg: require('../../static/img/方胜磐石——复星联合@2x.png'),
          text: '复星联合',
          text1: '康乐一生重大疾病保险（B款升级款）',
          path: '/fsproducts?id=7',
          id: '7'

        }
      ]
    }
  },
  mounted() {
    if(this.isMobile()) {
          this.$router.push({ path: "/products" });
        } else {
          this.$router.push({ path: "/cpxz?page=3" });
        }
  },
  methods: {
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>
<style lang="scss" scoped>
.cent{
  margin: 0 auto;
  width: 92%;
  }
.banner {
  width: 100%;
  height: 3.4rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.fzkj{
  .title{
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: .3rem .3rem;
        p{
            width: 1.8rem;
            color: #004b9e;
            font-size: .28rem;
            // padding-left: .2rem;
            .title_txt{
                padding-left: .2rem;
                font-weight: 600;
            }
            .xian{
                background-color: #054da0;
                width: .06rem;
                height: .28rem;
                border-radius: .02rem ;
                display: inline-block;
            }
        }
  }
  .fzkj_list{
    display: flex;
    justify-content:space-between;
    flex-wrap: wrap;
    li{
      width: 2.2rem;
      height: 3.2rem;
      position: relative;
      margin-bottom: .2rem;
      img{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
      .listTxt{
        position: absolute;
        bottom: 0.1rem;
        font-size: .16rem;
        padding: 0 .1rem;
        color: #717375;
        line-height: .3rem;
        h4{
          font-size: .22rem;
          text-align: center;
          color: #323436;
          line-height: .44rem;
          font-weight: 600;
          // padding-top: .1rem;
        }

      }
    }
  }
  .xhwb_list{
    display: flex;
    justify-content:space-between;
    flex-wrap: wrap;
    li{
      width: 3.4rem;
      height: 1.7rem;
      display: flex;
      justify-content:space-between;
      margin-bottom: .1rem;
      background-color: #eef1f6;
      border-radius: .08rem;
      img{
        display: inline-block;
        width: 1.8rem;
        height: 1.7rem;
      }
      .listTxt{
        font-size: .16rem;
        padding: 0 .2rem 0 .1rem;
        color: #717375;
        line-height: .32rem;
        h4{
          font-size: .22rem;
          color: #323436;
          line-height: .44rem;
          font-weight: 600;
        }

      }
    }

  }
  .fsps_list{
    li{
      width: 100%;
      height: 2rem;
      display: flex;
      justify-content:flex-start;
      margin-bottom: .4rem;
      img{
        display: inline-block;
        width: 2rem;
        height: 2rem;
      }
       .listTxt{
        font-size: .22rem;
        padding: 0 .4rem 0 .3rem;
        color: #717375;
        line-height: .35rem;
        h4{
          font-size: .26rem;
          color: #323436;
          line-height: .55rem;
          font-weight: 600;
        }
        p{
          line-height: .35rem;
        }
        .more{
          width: 4.5rem;
          height: .85rem;
          border-top: 1px solid #ebeef2;
          padding-top: .25rem;
          margin-top: .3rem;
          display: flex;
          justify-content: space-between;
          img{
              display: inline-block;
              width: .06rem;
              height: .32rem;
          }
          span:nth-child(1){
            display: inline-block;
            width: 1.2rem;
            height: .4rem;
            border:1px solid #db1223;
            border-radius: .1rem;
            text-align: center;
            color: #db1223;
          }
          
        }

      }
    }


  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Products.vue